module.exports = __webpack_public_path__ + "img/frs1.220bc1b5.jpg";